const DATETIME_LOCAL_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;
const HAS_TIMEZONE_SUFFIX = /[zZ]|[+-]\d{2}:\d{2}$/;

export const toDatetimeLocal = (value) => {
  if (!value) return "";
  const raw = String(value).trim();
  // API LocalDateTime (no timezone suffix): preserve wall-clock time for datetime-local input.
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(raw) && !HAS_TIMEZONE_SUFFIX.test(raw)) {
    return raw.slice(0, 16);
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const timezoneOffsetMs = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - timezoneOffsetMs).toISOString().slice(0, 16);
};

/** datetime-local -> naive LocalDateTime string for article APIs (no UTC shift). */
export const fromDatetimeLocalToLocalDateTime = (value) => {
  if (!value) return undefined;
  const normalized = String(value).trim();
  if (!DATETIME_LOCAL_PATTERN.test(normalized)) return undefined;
  return `${normalized}:00`;
};

export const splitDatetimeLocal = (value) => {
  const normalized = String(value || "").trim();
  if (!normalized.includes("T")) {
    return { date: "", time: "" };
  }
  const [date, time = ""] = normalized.split("T");
  return {
    date: date || "",
    time: time.slice(0, 5),
  };
};

export const mergeDatetimeLocal = (date, time) => {
  const normalizedDate = String(date || "").trim();
  const normalizedTime = String(time || "").trim();
  if (!normalizedDate || !normalizedTime) {
    return "";
  }
  return `${normalizedDate}T${normalizedTime}`;
};

export const isCompleteDatetimeLocal = (value) => {
  const { date, time } = splitDatetimeLocal(value);
  return Boolean(date && time);
};

export const toOffsetISOString = (value) => {
  if (!value) return undefined;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? undefined : date.toISOString();
};
